(function () {
  "use strict";

  UpdateCoursesInSeriesForTraineesCtrl.$inject = ['$scope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('UpdateCoursesInSeriesForTraineesCtrl', UpdateCoursesInSeriesForTraineesCtrl);

  function UpdateCoursesInSeriesForTraineesCtrl($scope, $timeout) {
    $scope.modal = {
      content: 0,
      data: {},
      status: ''
    };

    $scope.updateSeriesForTrainees = function () {
      $scope.modal.status = 'saving';
      $scope.$emit('seriesBulkUpdateConfirmed', $scope.modal.data, function () {
        $scope.dismiss();
        $timeout(function () {
          $scope.modal.status = ''
        }, 500);
      });
    };

    $scope.$on('seriesBulkUpdateRequested', function (event, numberOfTrainees, trainerEmail) {
      $scope.modal.status = '';
      $scope.modal.data = {};
      $scope.modal.content = numberOfTrainees;
      $scope.modal.trainerEmail = trainerEmail;
    });

    $scope.$on('seriesUpdateRequested', function (event, trainee, trainerEmail) {
      if (!trainee) return;
      $scope.modal.content = 1;
      $scope.modal.data = [trainee];
      $scope.modal.trainerEmail = trainerEmail;
      $scope.show();
    });
  }

})();
